<template>
  <div class="detail">
    <Tabs></Tabs>
    <div class="detalbd">
      <div class="titles" v-html="detailinfo.post_title.replace(/\n|\r\n/g, '<br>').replace(/ /g, '  ')"></div>
      <div class="titlesa">
        <span>时间：{{ detailinfo.published_time }}&nbsp;&nbsp;</span>
        <span>来源：{{ detailinfo.post_source ? detailinfo.post_source : "无" }}&nbsp;&nbsp;</span>
        <span>责任编辑：admin</span>
      </div>
      <div class="videoinfo">
        <video v-if="detailinfo.more && detailinfo.more.video" width="100%" :src="detailinfo.more ? detailinfo.more.video : ''" type="video/mp4"
               controls></video>
        <div class="detailinfo" v-html="detailinfo.post_content"></div>
      </div>
      <!-- <div v-if="categoryid !== 83" class="detailinfo" v-html="detailinfo.post_content"></div> -->
    </div>
  </div>
</template>

<script>
import Tabs from "@/components/tabs.vue";

export default {
  name: "",
  props: {},
  data() {
    return {
      id: "",
      categoryid: "",
      detailinfo: {},
    };
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {
    "$route.query": {
      immediate: true, // 启用初始化监测
      handler(newVal, oldVal) {
        this.categoryid = newVal.categoryid;

        this.id = newVal.postid;
        // this.postid = newVal.postid;
        this.getdetail();
        // 你可以在这里根据新的查询参数执行相应的操作
      },
    },
  },
  methods: {
    getdetail() {
      this.$api.get({
        url: "articles/read",
        data: {
          id: this.id,
        },
        success: (res) => {
          // console.log(res);
          this.detailinfo = res.data;
          //   this.articlesname = res.data.name;
        },
      });
    },
  },
  components: {
    Tabs,
  },
};
</script>

<style scoped lang="scss">
@media all and (max-width: 800px) {
  .detail {
    margin-bottom: 80px!important;
    .detalbd {
      width: 95% !important;
      .titles {
        width: 100% !important;
        font-size: 18px !important;
        text-align: center;
      }
      .titlesa {
        font-size: 12px !important;
      }
    }
  }
}
.detail {
  margin-bottom: 20px;
  .detalbd {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1170px;
    min-height: 920px;
    margin: 0 auto;
    color: #000;
    margin-top: 20px;
    border: 1px solid #c50909;
    border-top: 3px solid #c50909;
    background: #fff8f8;
    padding: 20px;
    .titles {
      display: flex;
      justify-content: center;
      width: 80%;
      color: #c50909;
      font-size: 25px;
      padding-bottom: 15px;
      border-bottom: 2px solid #f9dbdd;
      font-weight: bold;
      text-align: center;
    }
    .titlesa {
      margin-top: 10px;
      font-size: 15px;
      color: #8e93a0;
    }
    .videoinfo {
      display: flex;
      flex-direction: column;
      align-items: center;
      // margin-top: 15px;
      width: 100%;
      text-align: justify;
      video{
        margin-top: 15px;
      }
      img{
        height: auto !important;
      }
    }
    .detailinfo {
      margin-top: 15px;
      width: 100%;
      text-align: justify;
      p {
        word-wrap: break-word !important;
      }
    }
    .detailinfo /deep/ img {
      max-width: 90% !important;
      height: auto !important;
    }
    .detailinfo /deep/ video {
      max-width: 100% !important;
      height: auto !important;
    }
  }
}

.detailinfo {
  /deep/ p {
    word-wrap: break-word !important;
  }
  /deep/ span {
    word-wrap: break-word !important;
  }

}
</style>
